export default __webpack_public_path__ + "static/media/load.6c1faba1.gif";